import React, { useState, useEffect } from 'react';
import PhoneInput from 'react-phone-input-2';
import labelsPL from 'react-phone-input-2/lang/pl.json';
import { FormControl, Typography } from '@mui/material';
import { RequiredField } from '../others/RequiredField';

export const PhoneNumberField = ({ field, formik }) => {
  const [localValue, setLocalValue] = useState(formik.values[field.name] || '');
  const [countryData, setCountryData] = useState(null);

  const showError =
    formik.touched[field.name] && Boolean(formik.errors[field.name]);

  // Debounce
  useEffect(() => {
    const handler = setTimeout(() => {
      if (localValue !== formik.values[field.name]) {
        const normalized = localValue.startsWith('+')
          ? localValue
          : `+${localValue}`;
        formik.setFieldValue(field.name, normalized);
      }
    }, 1000);

    return () => clearTimeout(handler);
  }, [localValue]);

  const handleChange = (value, cData) => {
    setLocalValue(value);
    setCountryData(cData);
  };

  const isPhoneEmpty = value => {
    if (!value) {
      return true;
    };
    const digits = value.replace(/\D/g, '');
    const dialCode = countryData?.dialCode || '';

    return digits === '' || digits === dialCode;
  };

  return (
    <FormControl fullWidth sx={{ pb: 2 }}>
      <Typography variant="subtitle1">
        <b>{field.label}</b>
        <RequiredField
          required={field.required}
          isEmpty={isPhoneEmpty(formik.values[field.name])}
          formikError={showError}
        />
      </Typography>

      <PhoneInput
        specialLabel=""
        country="pl"
        countryCodeEditable={false}
        value={localValue}
        onChange={handleChange}
        onBlur={() => formik.setFieldTouched(field.name, true)}
        localization={labelsPL}
        inputStyle={{
          width: '100%',
          height: '56px',
          fontSize: '0.875rem',
          borderRadius: 4,
          border: showError ? '1px solid #FF4842' : '1px solid #54D62C',
          backgroundColor: 'white',
          outline: 'none',
          transition: 'border-color 0.2s'
        }}
      />

      {showError && (
        <Typography sx={{ mt: 0.5, ml: '14px', fontSize: 12 }} color="error">
          {formik.errors[field.name]}
        </Typography>
      )}
    </FormControl>
  );
};
